import { useMemo } from 'react'
import { RRuleSet, rrulestr } from 'rrule'

import { RECURRING_TYPE } from 'civic-champs-shared/core/utils/constants/RECURRING_TYPE_OPTIONS'
import { OpportunityResponseWithRecurrenceInfo } from 'Event/interfaces/interfaceCreateEditEvent'

export const isSingleEvent = (event: OpportunityResponseWithRecurrenceInfo): boolean => {
  const { sequenceInfo, is_recurring, recurring_type } = event

  if (sequenceInfo?.computedPattern) {
    const rrules = rrulestr(sequenceInfo.computedPattern, { forceset: true }) as RRuleSet
    return rrules.rdates().length === 1 && rrules.rrules().length <= 0
  }

  return !is_recurring || recurring_type === RECURRING_TYPE.NEVER
}

export const useIsSingleEvent = (event: OpportunityResponseWithRecurrenceInfo): boolean =>
  useMemo<boolean>(() => isSingleEvent(event), [event])
